// The authenticated shell. A pathless layout route (`_app`) so that every
// screen the sales team uses sits behind one guard, without `/app` appearing
// in any URL.
//
// Feature screens (board, catalogue, capture) are NOT this task's job. What
// this file establishes is the guard, plus the app bar / bottom tab bar shell
// chrome (AppShell) every authenticated screen renders inside — see
// components/shell/app-shell.tsx for the hide/show contract.
import { createFileRoute, redirect } from '@tanstack/react-router';

import { AppShell } from '@/components/shell/app-shell';
import { useSessionStore, waitForSessionBoot } from '@/lib/auth/session';

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ location }) => {
    // Boot reads the session mirror out of IndexedDB. It does NOT wait on the
    // network — see lib/auth/session.ts — so this await is a few milliseconds
    // even in airplane mode. Awaiting the network here instead would put a
    // full request timeout in front of every cold start at a booth.
    await waitForSessionBoot();

    if (useSessionStore.getState().status !== 'authenticated') {
      throw redirect({
        to: '/login',
        search: { redirect: location.href }
      });
    }
  },
  component: AppShell
});
